import $ from "jquery";
import axios from "axios";

$(function() {

    initSuggestionsButton();

    initProductTileItem();

    initAddOrderItemsToBasket();

    initBasketSummaryToggle();

});

window.customUpdateBasket = function (data) {

    // This function is called by the updateBasket routine in the ecommerce package
    // and can be used to make project specific changes to the basket form.

    // Not sure if these are really necessary ...
    // // Check if the extension object exists and if the message is set and reload the page if it is
    // if (data.extension && data.extension.message) {
    //     //console.log('reloading');
    //     location.reload();
    // }
    //
    // if (data.extension && !data.extension.message) {
    //     if ($('.basket-message-wrapper').length > 0) {
    //         //console.log('reloading');
    //         location.reload();
    //     }
    // }
    //
    // let continueButton = $('.checkout-link').length;
    // //console.log(continueButton, data.extension.is_checkout_allowed);
    // if (data.extension && (data.extension.is_checkout_allowed != continueButton)) {
    //     //console.log('reloading');
    //     location.reload();
    // }

    //console.log('customUpdateBasket');

    // Alert now handled by getBasketUpdatedAlert() below
    //showAlert('Alert', 'Your basket has been updated.', '', 2);

    // // Check if there is a flash message already displayed
    // let hasFlashMessage = ($('.flash-message').length > 0);
    // let hasNewMessage = (data.message != '');
    //
    // if (hasFlashMessage && hasNewMessage) {
    //     $('.flash-message').text(data.message);
    // } else if (hasFlashMessage != hasNewMessage) {
    //     // We either have a new message, or we need to clear the old one - needs a screen refresh
    //     location.reload();
    // }

}


function initSuggestionsButton() {

    $('.suggestions-button').unbind('click');

    $('.suggestions-button').on('click', function() {

        if ($(this).hasClass('show')) {
            // We are showing the suggestions table
            $(this).parent().find('.suggestions-table').removeClass('hide');
            $(this).removeClass('show').text('Hide suggestions');
        } else {
            // We are hiding the suggestions
            $(this).parent().find('.suggestions-table').addClass('hide');
            $(this).addClass('show').text('Show suggestions');
        }

    });

}


export function initProductTileItem() {

    //console.log('initProductTileItem');

    $(document).on('change', '.set-quantity', function(e) {

        let quantity = $(this).val();
        // Force the quantity to an integer if it isn't already ...
        quantity = parseInt(quantity);

        if (isNaN(quantity)) {
            quantity = 1;
        } else if (quantity < 0) {
            quantity = 1;
        }

        // As we now have different html structures for different buttons, get a wrapper object for finding elements
        let $wrapper = null;
        if ($(this).parent().parent().hasClass('actions')) {
            $wrapper = $(this).parent().parent();
        } else {
            $wrapper = $(this).parent();
        }

        let $button = $wrapper.find('button[data-item-quantity]').first();

        // There might be more than one button on the page to update
        let $buttons = $('button.add[data-product-id=' + $button.attr('data-product-id') + ']');

        // Get the quantity inputs
        let $quantityInputs = $wrapper.find('input.quantity');

        // Update the input value, just in case we had something weird ...
        $quantityInputs.val(quantity);

        // Check the stock level
        let quantityInStock = $button.attr('data-item-quantity-in-stock');

        if (quantity > quantityInStock) {

            // Update the quantity allowed
            quantity = quantityInStock;
            $quantityInputs.val(quantity);

            // Show a notification
            let message = `
                <div class="quantity-alert">
                    <h3>Quantity alert</h3>
                    <p>Your requested quantity of this product is more than we currently have in stock.  Your quantity has been reduced accordingly.</p>
                </div>
            `;
            $('body').append(message);

            setTimeout(() => {
                $('.quantity-alert').fadeOut(250,function() {
                    $('.quantity-alert').remove();
                });
            }, 2000);

        }

        $buttons.attr('data-item-quantity', quantity);

    });


    $(document).on('click', '.add-item', function(e) {

        //console.log('add-item');

        let $target = $(this);
        let productVariantId = $target.attr('data-product-variant-id');
        let productId = $target.attr('data-product-id');
        let itemQuantity = $target.attr('data-item-quantity');
        let itemPrice = $target.attr('data-item-price');

        let type = '';
        if ($target.parents('.product-tile').length) {
            type = 'product-tile';
        } else if (($target.parents('.price-wrapper').length) || ($target.parents('.sticky-add-to-basket').length)) {
            type = 'product-detail';
        }

        $target.html('Adding <i class="fa-solid fa-basket-shopping"></i>');

        return axios.post('/basket/add-item', {
            productVariantId: productVariantId,
            productId: productId,
            itemQuantity: itemQuantity,
            itemPrice: itemPrice,
            type: type
        }).then(function (response) {

            //console.log(response);

            if (response.data.items) { updateItems(response.data.items); }
            if (response.data.actions) { processActions(response.data.actions, type, $target); }
            if (response.data.summary) { processSummary(response.data.summary); }
            if (response.data.basketUpdatedAlert) { processBasketUpdatedAlert(response.data.basketUpdatedAlert); }
            if (response.data.items) { customUpdateBasket(response.data.items); }
            if (response.data.basketFooter) { processBasketFooter(response.data.basketFooter); }

            if (response.data.ga4 && (response.data.ga4 != '')) {
                // Clear the dataLayer ecommerce object
                dataLayer.push({ecommerce: null});
                // Add the new ga4 data
                dataLayer.push(response.data.ga4);
            }

        }).finally(function (error) {
            if (itemQuantity > 0) {
                $target.html('Update <i class="fa-solid fa-basket-shopping"></i>');
            } else {
                $target.html('Add <i class="fa-solid fa-basket-shopping"></i>');
            }
        }).catch(function (error) {
            console.log(error);
        });
    });

    $(document).on('click', '.update-item', function(e) {

        //console.log('update-item');

        let $target = $(this);
        let productVariantId = $target.attr('data-product-variant-id');
        let productId = $target.attr('data-product-id');
        let basketItemId = $target.attr('data-basket-item-id');
        let itemQuantity = $target.attr('data-item-quantity');
        let itemPrice = $target.attr('data-item-price');

        let type = '';
        if ($target.parents('.product-tile').length) {
            type = 'product-tile';
        } else if (($target.parents('.price-wrapper').length) || ($target.parents('.sticky-add-to-basket').length)) {
            type = 'product-detail';
        }

        // console.log({
        //     productVariantId: productVariantId,
        //     productId: productId,
        //     basketItemId: basketItemId,
        //     itemQuantity: itemQuantity,
        //     itemPrice: itemPrice,
        //     type: type
        // });

        $target.html('Updating <i class="fa-solid fa-basket-shopping"></i>');

        return axios.post('/basket/update-item', {
            productVariantId: productVariantId,
            productId: productId,
            basketItemId: basketItemId,
            itemQuantity: itemQuantity,
            itemPrice: itemPrice,
            type: type
        }).then(function (response) {

            if (response.data.items) { updateItems(response.data.items); }
            if (response.data.actions) { processActions(response.data.actions, type, $target); }
            if (response.data.summary) { processSummary(response.data.summary); }
            if (response.data.basketUpdatedAlert) { processBasketUpdatedAlert(response.data.basketUpdatedAlert); }
            if (response.data.items) { customUpdateBasket(response.data.items); }
            if (response.data.basketFooter) { processBasketFooter(response.data.basketFooter); }

            if (response.data.ga4 && (response.data.ga4 != '')) {
                // Clear the dataLayer ecommerce object
                dataLayer.push({ecommerce: null});
                // Add the new ga4 data
                dataLayer.push(response.data.ga4);
            }

        }).finally(function (error) {
            if (itemQuantity > 0) {
                $target.html('Update <i class="fa-solid fa-basket-shopping"></i>');
            } else {
                $target.html('Add <i class="fa-solid fa-basket-shopping"></i>');
            }
        }).catch(function (error) {
            console.log(error);
        });

    });

    $(document).on('click', '.delete-item', function(e) {

        let start = Date.now();

        let $target = $(this);
        let productVariantId = $target.attr('data-product-variant-id');
        let productId = $target.attr('data-product-id');
        let basketItemId = $target.attr('data-basket-item-id');
        let itemQuantity = $target.attr('data-item-quantity');
        let itemPrice = $target.attr('data-item-price');

        let type = '';
        if ($target.parents('.product-tile').length) {
            type = 'product-tile';
        } else if (($target.parents('.price-wrapper').length) || ($target.parents('.sticky-add-to-basket').length)) {
            type = 'product-detail';
        }

        let $lastButton = $target.parent().find('button').last();

        if ($lastButton.hasClass('update-item')) {
            $lastButton.html('Deleting <i class="fa-solid fa-basket-shopping"></i>');
        }

        return axios.post('/basket/delete-item', {
            productVariantId: productVariantId,
            productId: productId,
            basketItemId: basketItemId,
            itemQuantity: itemQuantity,
            itemPrice: itemPrice,
            type: type
        }).then(function (response) {

            //console.log(response);

            if (response.data.items) { updateItems(response.data.items); }
            if (response.data.actions) { processActions(response.data.actions, type, $target); }
            if (response.data.summary) { processSummary(response.data.summary); }
            if (response.data.basketUpdatedAlert) { processBasketUpdatedAlert(response.data.basketUpdatedAlert); }
            if (response.data.items) { customUpdateBasket(response.data.items); }
            if (response.data.basketFooter) { processBasketFooter(response.data.basketFooter); }

            if (response.data.ga4 && (response.data.ga4 != '')) {
                // Clear the dataLayer ecommerce object
                dataLayer.push({ecommerce: null});
                // Add the new ga4 data
                dataLayer.push(response.data.ga4);
            }

        })
            .catch(function (error) {
                console.log(error);
            });

    });

    $(document).on('click', '.alert-when-in-stock', function(e) {

        //console.log('alert-when-in-stock click');

        let productId = $(this).attr('data-product-id');

        return axios.post('/account/product-alert', {
            productId: productId
        })
            .then(function (response) {
                if (response.data) {
                    //console.log(response);
                    if (response.data) {
                        let $button = $('.alert-when-in-stock[data-product-id=' + response.data + ']');
                        $button.removeClass('alert-when-in-stock').addClass('stock-alert-set');
                        $button.html('Stock alert set <i class="fa-solid fa-check"></i>');
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });

    });


}

// // Global wrapper to allow collection pages to reinitialise tiles after a Livewire reload
// window.reInitProductTileItem = function () {
//     console.log('reInitProductTileItem');
//     initProductTileItem();
// }

function updateItems(itemsData) {

    if (itemsData) {
        if (itemsData.basket_item_count === 0) {
            $('.product-list.basket').html('<p>Your basket is empty</p>');
        } else {

            if ($('.product-list.basket').length) {
                //console.log('request to /manager/basket/items');
                return axios.post('/manager/basket/items')
                    .then(function (response) {
                        //console.log(response);
                        if (response.data) {
                            // Clear out the old items
                            $('.product-list.basket .product-tile').remove();
                            $('.product-list.basket').prepend(response.data);
                            //initProductTileItem();
                            window.initPopulateProductPrices();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            } else if ($('.product-list.suggestions').length) {
                //console.log('request to /manager/basket/suggestions');
                return axios.post('/manager/basket/suggestions')
                    .then(function (response) {
                        //console.log(response);
                        if (response.data) {
                            // Clear out product tiles
                            $('.product-list.suggestions .product-tile').remove();
                            // Add new regulars
                            if ($('.product-list-header.regulars').length) {
                                $('.product-list-header.regulars').after(response.data.regulars);
                            }
                            // Add new incompletes
                            if ($('.product-list-header.incompletes').length) {
                                $('.product-list-header.incompletes').after(response.data.incompletes);
                            }
                            // Add new offers
                            if ($('.product-list-header.offers').length) {
                                $('.product-list-header.offers').after(response.data.offers);
                            }
                            //initProductTileItem();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    }

    setTimeout(window.initPopulateProductPrices, 500);

}


function updateActions($target) {

    //console.log('updateActions');
    //console.log($target);

    let type = '';

    if ($target.parents('.product-tile').length) {
        type = 'product-tile';
    } else if (($target.parents('.price-wrapper').length) || ($target.parents('.sticky-add-to-basket').length)) {
        type = 'product-detail';
    }

    if (!type) {
        return '';
    }

    let productId = $target.attr('data-product-id');
    return axios.post('/basket-item/get-actions', {
        productId: productId,
        type: type
    }).then(function (response) {

        if (response.data) {
            processActions(response.data, type, $target);
        }

    }).catch(function (error) {
        console.log(error);
    });

}

function processActions(actionsData, type, $target) {

    //console.log(actionsData, type, $target);

    if (type == '') {
        return;
    }

    if (type === 'product-tile') {
        let $productTile = $target.parents('.product-tile');
        $productTile.find('.actions').replaceWith(actionsData.actions);
        if ($productTile.find('.offer-wrapper').length) {
            if (actionsData.offer) {
                $productTile.find('.offer-wrapper').replaceWith(actionsData.offer);
            } else {
                $productTile.find('.offer-wrapper').remove();
            }
        } else if (actionsData.offer) {
            $productTile.find('.image-wrapper').after(actionsData.offer);
        } else if ($productTile.find('.status-wrapper').length) {
            if (actionsData.status) {
                $productTile.find('.status-wrapper').replaceWith(actionsData.status);
            } else {
                $productTile.find('.status-wrapper').remove();
            }
        } else if (actionsData.status) {
            $productTile.find('.image-wrapper').after(actionsData.status);
        }
        //initProductTileItem();
        resetOfferDetail();
    } else if (type === 'product-detail') {
        let $productItemWrapper = $('.product-item-wrapper').first();
        $productItemWrapper.find('.price-wrapper').replaceWith(actionsData.wrapper);
        if ($productItemWrapper.find('.offer-wrapper').length) {
            if (actionsData.offer) {
                $productItemWrapper.find('.offer-wrapper').replaceWith(actionsData.offer);
            } else {
                $productItemWrapper.find('.offer-wrapper').remove();
            }
        } else if (actionsData.offer) {
            $productItemWrapper.find('.description-wrapper').prepend(actionsData.offer);
        } else if ($productItemWrapper.find('.status-wrapper').length) {
            if (actionsData.status) {
                $productItemWrapper.find('.status-wrapper').replaceWith(actionsData.status);
            } else {
                $productItemWrapper.find('.status-wrapper').remove();
            }
        } else if (actionsData.status) {
            $productItemWrapper.find('.description-wrapper').prepend(actionsData.status);
        }
        $('.sticky-add-to-basket').replaceWith(actionsData.sticky);
        //initProductTileItem();
        resetOfferDetail();
    }

}

function resetOfferDetail() {

    $('.show-offer-detail').unbind('click');
    $('.show-offer-detail').on('click', function() {

        let offerId = $(this).attr('data-offer-id');

        return axios.post('/offer/details', {
            offerId: offerId
        }).then(function (response) {
            if (response.data) {
                $('.wrapper-offers .inner').html(response.data);
                $('.wrapper-offers').css({'top': '0'});
                $('.wrapper-offers-mask').delay(350).fadeIn(150);
                resetCloseOfferDetail();
            }
        })
            .catch(function (error) {
                console.log(error);
            });

    });

}


function resetCloseOfferDetail() {
    $('.close-offer-detail').click(function() {
        $('.wrapper-offers-mask').hide();
        $('.wrapper-offers').css({'top': '100%'});
        $('.wrapper-offers .inner').html('');
    });
}


function updateSummary() {

    return axios.post('/manager/basket/summary')
        .then(function (response) {
            //console.log(response);
            if (response.data) {
                processSummary(response.data);
            }
        })
        .catch(function (error) {
            console.log(error);
        });

}


function processSummary(summaryData) {

    $('.basket-summary-wrapper').replaceWith(summaryData.summary);
    $('.btnbasket').replaceWith(summaryData.button);

}


function processBasketFooter(basketFooter) {

    $('.basket-footer').replaceWith(basketFooter);

}


function getBasketUpdatedAlert() {

    //console.log('getBasketUpdatedAlert');

    return axios.post('/manager/basket/alert')
        .then(function (response) {
            //console.log(response);
            if (response.data) {
                processBasketUpdatedAlert(response.data);
            }
        })
        .catch(function (error) {
            console.log(error);
        });

}


function processBasketUpdatedAlert(basketUpdatedAlertData) {

    $('body').append(basketUpdatedAlertData.alert);

}


$(document).on('click', '.sticky-edit-close i', function(e) {
    //console.log('stickyEditClose');
    $('.sticky-edit-order').fadeOut();
});


function initAddOrderItemsToBasket() {

    //console.log(initAddOrderItemsToBasket);

    $('.add-items-to-basket').unbind('click');
    $('.add-items-to-basket').on('click', function() {

        //console.log('add-items-to-basket');
        let start = Date.now();

        let basketId = $(this).attr('data-basket-id');

        return axios.post('/manager/basket/add-basket-items', {
            basketId: basketId
        })
            .then(function (response) {
                //console.log(response);
                if (response.data) {
                    $('.basket-summary-wrapper').replaceWith(response.data.summary);
                    $('.btnbasket').replaceWith(response.data.button);
                }

                //console.log('add-items-to-basket duration ' + (Date.now() - start) + 's');

            })
            .catch(function (error) {
                console.log(error);
            });

    });

}


$(window).scroll(function() {

    if ($('.basket-summary-inner').length) {
        fixBasketSummaryInnerPosition();
    }

});

$(window).resize(function() {

    if ($('.basket-summary-inner').length) {
        fixBasketSummaryInnerPosition();
    }

});


function fixBasketSummaryInnerPosition() {

    let $basketSummaryInner = $('.basket-summary-inner').first();

    // console.log($basketSummaryInner);

    if (!$basketSummaryInner.length) {
        return;
    }

    if ($(window).width() <= 768) {
        if ($basketSummaryInner.hasClass('fixed')) {
            $basketSummaryInner.removeClass('fixed');
            $basketSummaryInner.css('top', '');
            $basketSummaryInner.css('left', '');
            $basketSummaryInner.css('width', '');
        }
        return;
    }

    let scrollTop = $(window).scrollTop();
    let $header = $('header').first();
    let headerHeight = $header.outerHeight();
    let $basketSummaryWrapper = $('.basket-summary-wrapper').first();
    let basketSummaryWrapperTop = $basketSummaryWrapper.offset().top;
    let $basketInner = $('.basket-inner').first();
    let basketInnerMargin = parseInt($basketInner.css('margin-top'));
    let compareTop = (scrollTop + headerHeight + basketInnerMargin);

    // console.log('basketSummaryWrapper position: left: ' + $basketSummaryWrapper.offset().left + ', width: ' + $basketSummaryWrapper.outerWidth());

    if (basketSummaryWrapperTop < compareTop) {
        let fixedTop = (headerHeight + basketInnerMargin) + 'px';
        let fixedLeft = $basketSummaryWrapper.offset().left;
        let fixedWidth = $basketSummaryWrapper.outerWidth();
        $basketSummaryInner.addClass('fixed');
        $basketSummaryInner.css('top', fixedTop);
        $basketSummaryInner.css('left', fixedLeft);
        $basketSummaryInner.css('width', fixedWidth);
    } else {
        $basketSummaryInner.removeClass('fixed');
        $basketSummaryInner.css('top', '');
        $basketSummaryInner.css('left', '');
        $basketSummaryInner.css('width', '');
    }

}


function initBasketSummaryToggle() {

    $(document).on('click', '.basket-summary-toggle', function(e) {
        if ($(this).find('i').hasClass('fa-angle-down')) {
            $('.basket-summary-content').removeClass('hide-mobile');
        } else {
            $('.basket-summary-content').addClass('hide-mobile');
        }
        $(this).find('i').toggleClass('fa-angle-down').toggleClass('fa-angle-up');
    });

}

